import { createContext, useContext } from "react";

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  roles: string[];
  studies: string[];
  sites: string[];
  askSites: string[];
}

export interface AuthContextValue {
  user: AuthUser | null;
  loading: boolean;
  setUserInfo: (raw: Record<string, unknown>) => void;
  clearUser: () => void;
  refreshUser: (options?: { forceTokenRefresh?: boolean }) => Promise<AuthUser | null>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue>({
  user: null,
  loading: false,
  setUserInfo: () => undefined,
  clearUser: () => undefined,
  refreshUser: async () => null,
  logout: async () => undefined,
});

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}
